
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.se-event-registration{
  background-color:var(--brand-secondary-4);
  display:inline-flex;
  flex-direction:column;
  align-items:center;
  padding:var(--spacing-14) var(--spacing-12);
  max-width:300px;
  text-align:center;
}

  .se-event-registration__type{
    text-transform:uppercase;
    font-family:var(--ff-rift);
    font-size:var(--fs-base);
    color:var(--brand-primary-1);
  }

  .se-event-registration__format{
    font-size:var(--fs-xs);
  }

  .se-event-registration__time{
    font-size:var(--fs-base);
    padding-bottom:var(--spacing-4);
  }

  .se-event-registration__date{
    font-size:var(--fs-xl);
    font-weight:var(--fw-bold);
    padding-bottom:var(--spacing-5);
    padding-top:var(--spacing-5);
    text-align:center;
  }

  .se-event-registration__address{
    padding-bottom:var(--spacing-2);
  }

  .se-event-registration__address a{
      color:var(--brand-primary-2);
      text-decoration:none;
      font-size:var(--fs-base);
      font-weight:var(--fw-bold);
    }

  .se-event-registration__address a:hover{
        text-decoration:underline;
      }

  .se-event-registration_remote-link-btn{
    padding-top:var(--spacing-3);
  }
`;